<style scoped>
 
</style>

<template lang="pug">
  div
    app-navigation
    router-view
</template>
<script>
import AppNavigation from '@/components/app-navigation'

export default {
  components: {
    AppNavigation
  }
}
</script>



// WEBPACK FOOTER //
// src/components/template-dashboard.vue